import {call, put, takeEvery} from "redux-saga/effects";
import CallCenterService from "../services/api/CallCenterService";
import VehicleService from "../services/api/VehicleService";
import * as types from "../constants/ActionTypes";
import * as actions from "../actions/callCenterActions";

function* lookupVin({payload}) {
  try {
    let ivsCallCenterResults = [];
    if (payload && payload.length >= 4 && payload.length <= 17) {
      ivsCallCenterResults = yield call(CallCenterService.getIvsVehicles, payload);
    }
    yield put(actions.fetchCallCenterIvsVinSuccess(ivsCallCenterResults.body));
  } catch (error) {
    yield put(actions.fetchCallCenterIvsVinFailure(error));
  }
}

function* fetchVehicleProperties({payload}) {
  try {
    const vehicleProperties = yield call(VehicleService.getVehicleProperties, payload);
    yield put(actions.fetchVehiclePropertiesSuccess(vehicleProperties.body));
  } catch (error) {
    yield put(actions.fetchVehiclePropertiesFailure(error));
  }
}

function* fetchCustomer({payload}) {
  try {
    const userVehicle = yield call(CallCenterService.getCustomerVehicleByVin, payload);
    yield put(actions.fetchCustomerSuccess(userVehicle.body));
  } catch (error) {
    yield put(actions.fetchCustomerFailure(error));
  }
}

export function* watchCallCenterVinLookup() {
  yield takeEvery(types.FETCH_CALL_CENTER_IVS_VIN, lookupVin)
}

export function* watchFetchVehicleProperties() {
  yield takeEvery(types.FETCH_CALL_CENTER_VEHICLE_PROPERTIES, fetchVehicleProperties)
}

export function* watchFetchCustomer() {
  yield takeEvery(types.FETCH_CUSTOMER_INFORMATION, fetchCustomer)
}
